import { startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function pipelineStartCoroutineUninterceptedOrReturn(interceptor, context, subject, continuation) {
  var coroutine = pipelineStartCoroutineUninterceptedOrReturn$slambda(interceptor, context, subject);
  // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
  return startCoroutineUninterceptedOrReturnGeneratorVersion(coroutine, continuation);
}
function pipelineStartCoroutineUninterceptedOrReturn$slambda($interceptor, $context, $subject) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $($interceptor($context, $subject, $completion), $completion);
    return Unit_instance;
  }), 0);
}
//region block: exports
export {
  pipelineStartCoroutineUninterceptedOrReturn as pipelineStartCoroutineUninterceptedOrReturn3fvxhza76tp2,
};
//endregion

//# sourceMappingURL=Pipeline.web.mjs.map
